import { render, staticRenderFns } from "./ListTopPosts.vue?vue&type=template&id=14ef0f00&scoped=true&"
import script from "./ListTopPosts.vue?vue&type=script&lang=ts&"
export * from "./ListTopPosts.vue?vue&type=script&lang=ts&"
import style0 from "./ListTopPosts.vue?vue&type=style&index=0&id=14ef0f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ef0f00",
  null
  
)

export default component.exports